module.exports = __webpack_public_path__ + "static/media/week-measurements-500.957c5e31.svg";